import { type IBase } from "@/interfaces/api/base.interface"
import { type ILockData } from "@/interfaces/socket/lock-data.interface"

export interface IIncomingSocketMessage<DataType extends IBase | undefined = undefined> {
  type: IncomingSocketMessageTypes
  details: {
    model: string
    data: DataType | ILockData
    // True when `data` is in normalize_data's {structure, objects} shape and needs denormalising.
    // It no longer means "the payload was withheld and must be fetched separately": bulk payloads
    // travel inline now.
    isBulk: boolean
  }
  sender: string | null // String if caused by a user, null if caused by the system (e.g. join table updates).
}

export enum IncomingSocketMessageTypes {
  MODEL_CREATE = "model_create",
  MODEL_UPDATE = "model_update",
  MODEL_DELETE = "model_delete",
  MODEL_LOCK = "model_lock",
  MODEL_RELEASE = "model_release",
  COMMAND = "command"
}
